import { createAxiosClient } from '../axiosDefaults';
const IMAGES_API_PATH = '/classifieds-image';
export function createApi(baseUrl, config) {
  let axiosConfig = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  const axiosInstance = createAxiosClient({
    baseURL: "" + baseUrl + IMAGES_API_PATH,
    withCredentials: true,
    ...axiosConfig
  }, config);

  function uploadSelfEvaluationImage(_ref) {
    let {
      carleadHash,
      file,
      timeout = 90000
    } = _ref;
    const fd = new FormData();
    fd.append('file', file);
    return axiosInstance.post("car_hash/" + carleadHash, fd, {
      headers: {
        'content-type': 'application/x-www-form-urlencoded'
      },
      timeout
    }).then(res => res.data);
  }

  return {
    uploadSelfEvaluationImage,
    axiosInstance
  };
}